'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {
  return {};
};
var width = 2560;
var height = 1440;

var dims = {
  y: 0,
  x: 0,
  width: width,
  height: height,
  innerWidth: width,
  innerHeight: height,
  clientWidth: width,
  clientHeight: height
};

var elem = (0, _extends3.default)({}, dims, {
  getBoundingClientRect: function getBoundingClientRect() {
    return dims;
  }
});

var documentMock = (0, _extends3.default)({
  addEventListener: noop,
  removeEventListener: noop,
  createEvent: noop,
  getElementById: function getElementById() {
    return elem;
  },
  getElementsByClassName: function getElementsByClassName() {
    return [elem];
  },
  getElementsByTagName: function getElementsByTagName() {
    return [elem];
  },
  querySelector: function querySelector() {
    return [elem];
  },
  documentElement: elem,
  activeElement: elem,
  style: dims
}, dims);

documentMock.body = documentMock;

var locationMock = {
  href: 'http://mock.wix.com/',
  protocol: 'http:',
  host: 'mock.wix.com',
  hostname: 'mock.wix.com',
  port: '',
  pathname: '/',
  search: '',
  hash: ''
};

var windowMock = (0, _extends3.default)({
  isMock: true,
  isSSR: true,
  orientation: 0,
  devicePixelRatio: 1,
  scrollTop: 0,
  addEventListener: noop,
  removeEventListener: noop,
  createEvent: noop,
  CustomEvent: noop,
  screen: dims,
  open: noop,
  petri: {},
  search: {},
  location: locationMock,
  postMessage: noop,
  requestAnimationFrame: noop,
  dispatchEvent: noop,
  document: documentMock,
  getComputedStyle: noop,
  localStorage: {},
  frames: []
}, dims);

windowMock.parent = windowMock;

exports.default = windowMock;